import { ISSUE_API_ROOT } from '../constants';

export const getIssueComments = ({
  dataProvider,
  issueId,
  page = 1,
  limit = 10,
}) =>
  dataProvider.get(
    `${ISSUE_API_ROOT}/${issueId}/comments?page=${page}&limit=${limit}`,
  );

export const addIssueComment = ({ dataProvider, issueId, body }) =>
  dataProvider.post(`${ISSUE_API_ROOT}/${issueId}/comments`, { body });

export const updateIssueComment = ({
  dataProvider,
  issueId,
  commentId,
  body,
  recordVersion,
}) =>
  dataProvider.post(`${ISSUE_API_ROOT}/${issueId}/comments/${commentId}`, {
    body,
    recordVersion,
  });
